<template>
  <div class="w-100 py-4 d-flex flex-column align-items-center justify-content-center">
    <div style="width: 24rem;">
      <NoPlanSvg />
    </div>

    <span
      style="font-size: var(--font-lg);"
      class="mb-3 text-black text-center"
    >
      {{ message ?? "You need to choose a plan to access this feature" }}
    </span>

    <div style="margin: 0 auto; width: 100%; max-width: 10rem;">
      <Button
        rounded="lg"
        @click="goToPlan"
        testId="choose-plan-btn"
      >
        Choose Plan
      </Button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";

import { Button } from "@/components/global";
import { NoPlanSvg } from "@/components/svg";

interface Props {
  message?: string;
}

defineProps<Props>();
const router = useRouter();

const goToPlan = () => {
  router.push("/manage-plan");
};
</script>
